module.exports =
  template: require('./index.pug')()
  controller: require('./index.ctrl')
  bindings:
    salon: '<'
    refundPolicy: '<'
